import React from 'react';
import { FaUser, FaPhone, FaEdit, FaSave, FaTimes } from 'react-icons/fa';
import { useToastMessages } from '../../components/MessageToast/MessageToast';

const UserDetails = ({
  userData,
  setUserData,
  contactEdit,
  setContactEdit,
  handleContactSave,
}) => {
  const { showSuccess, showError, ToastContainer } = useToastMessages();

  const handleSave = async () => {
    try {
      await handleContactSave();
      showSuccess('Informațiile de contact au fost actualizate cu succes!');
    } catch (error) {
      showError('A apărut o eroare la salvarea datelor personale.');
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-2xl shadow-lg border border-blue-100">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 bg-blue-500 text-white flex items-center justify-center rounded-xl shadow-lg">
            <FaUser className="text-xl" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800">
              Profil Personal
            </h2>
            <p className="text-gray-600">
              Gestionează informațiile tale personale
            </p>
          </div>
        </div>

        {contactEdit ? (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <FaUser className="text-blue-500" />
                  Nume Complet
                </label>
                <input
                  type="text"
                  value={userData?.name || ''}
                  onChange={(e) =>
                    setUserData((prev) => ({ ...prev, name: e.target.value }))
                  }
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="Introduceți numele complet"
                />
              </div>
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <FaPhone className="text-blue-500" />
                  Număr de Telefon
                </label>
                <input
                  type="tel"
                  value={userData?.phone || ''}
                  onChange={(e) =>
                    setUserData((prev) => ({
                      ...prev,
                      phone: e.target.value,
                    }))
                  }
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="+40 123 456 789"
                />
              </div>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                onClick={handleSave}
                className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105 shadow-lg"
              >
                <FaSave />
                Salvează
              </button>
              <button
                onClick={() => setContactEdit(false)}
                className="flex items-center gap-2 bg-gray-500 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-medium transition-all"
              >
                <FaTimes />
                Anulează
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <FaUser className="text-blue-500" />
                  <span className="font-semibold text-gray-700">
                    Nume Complet
                  </span>
                </div>
                <p className="text-lg text-gray-800 font-medium">
                  {userData?.name || 'Nu este specificat'}
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <FaPhone className="text-blue-500" />
                  <span className="font-semibold text-gray-700">Telefon</span>
                </div>
                <p className="text-lg text-gray-800 font-medium">
                  {userData?.phone || 'Nu este specificat'}
                </p>
              </div>
            </div>

            <button
              onClick={() => setContactEdit(true)}
              className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105 shadow-lg"
            >
              <FaEdit />
              Modifică Datele
            </button>
          </div>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default UserDetails;
